import { Navigate } from 'react-router';

import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';

export interface NonEnterpriseGuardProps {
  children: React.ReactNode;
  fallback: string;
}

export const NonEnterpriseGuard = ({
  children,
  fallback,
}: NonEnterpriseGuardProps) => {
  const { isEnterprise, loaded } = useAccountStatus();

  if (loaded && isEnterprise) {
    return <Navigate to={fallback} />;
  }

  return <>{children}</>;
};
